import { render, staticRenderFns } from "./publicGallery.vue?vue&type=template&id=0990693d&scoped=true"
import script from "./publicGallery.vue?vue&type=script&lang=js"
export * from "./publicGallery.vue?vue&type=script&lang=js"
import style0 from "./publicGallery.vue?vue&type=style&index=0&id=0990693d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0990693d",
  null
  
)

export default component.exports